import { IField, IFilterResponse } from "../../filter/dto/filter.dto";
import { LoaderService } from "../../filter/Services/loaderService";
import { PaginationService } from "../../filter/Services/paginationService";
import { RenderService } from "../../filter/Services/renderService";
import { RequestService } from "../../filter/Services/requestService";

export class SearchRequest implements ISearchRequest {
  document: number = null;
  fields: { [key: string]: IField[] } = {};
  filterDefinitions: Array<IFilterDefinition> = new Array();
  filters: { [key: string]: string; } = {};
  nextPage: { [key: string]: number; } = {};
}

export interface ISearchRequest {
  document: number,
  fields: {
    [key: string]: Array<IField>
  },
  filterDefinitions: Array<IFilterDefinition>,
  filters: {
    [key: string]: string
  },
  nextPage : {
    [key: string]: number
  }
}

export interface IFilterDefinition {
  id: number,
  key: string
}

export interface IPage {
  id: number,
  key: string
}

export interface ISearchModel {
  [key: string]: IFilterResponse
}

export interface IFilters {
  key: string,
  id: number,
  element: HTMLElement,
  renderService: RenderService,
  loaderService: LoaderService,
  filterRequestService: RequestService,
  paginationService: PaginationService,
}
